/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Save_Interval_HelpInputs */



/**
* | output |
* | --- |
* | "How often your work will be automatically saved" |
*
* @param {Options_Backup_Save_Interval_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_save_interval_help = /** @type {((inputs?: Options_Backup_Save_Interval_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Save_Interval_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fréquence d'enregistrement automatique de votre travail")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie oft Ihre Arbeit automatisch gespeichert wird")
	if (locale === "it") return /** @type {LocalizedString} */ ("Con quale frequenza il tuo lavoro verrà salvato automaticamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Как часто ваша работа будет автоматически сохраняться")
	if (locale === "es") return /** @type {LocalizedString} */ ("Con qué frecuencia se guardará automáticamente su trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您的工作将多久自动保存一次？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業を自動的に保存する頻度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपका काम कितनी बार अपने आप सेव होगा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Com que frequência seu trabalho será salvo automaticamente?")
	return /** @type {LocalizedString} */ ("How often your work will be automatically saved")
});